import {
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { POSTCODE } from "../../../consts/layers";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  radioButton: {
    height: "30px",
    padding: "0px",
    "& .MuiFormControlLabel-label": {
      fontSize: "12px",
    },
  },
});

export const RemoveArtificialPostcodeContent = ({
  hasLocation,
  locationOnly,
  level,
  artificialPostcode,
  onLocationOnlyChange,
}) => {
  const styles = useStyles();
  if (level !== POSTCODE)
    return (
      <View className={styles.container}>
        {hasLocation ? (
          <View>
            Are you sure you want to remove {`${artificialPostcode.postcode} `}
            from the map?
          </View>
        ) : (
          <View>
            {`${artificialPostcode.postcode} `} has no marker on the map.
          </View>
        )}
      </View>
    );
  else
    return (
      <View className={styles.container}>
        <View>
          Would you like to remove {`${artificialPostcode.postcode}`} marker
          from the map only or remove it completely?
        </View>
        <View>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="location-only"
              name="locationOnly"
              value={!!locationOnly && hasLocation}
            >
              <FormControlLabel
                className={styles.radioButton}
                onClick={() => onLocationOnlyChange(true)}
                value={true}
                control={<Radio color={"primary"} size={"small"} />}
                label="Remove map marker only"
                disabled={!hasLocation}
              />
              <FormControlLabel
                className={styles.radioButton}
                onClick={() => onLocationOnlyChange(false)}
                value={false}
                control={<Radio color={"primary"} size={"small"} />}
                label="Remove postcode completely"
              />
            </RadioGroup>
          </FormControl>
        </View>
      </View>
    );
};
